'use client';

import { useCallback, useEffect, useState } from 'react';
import { usePathname, useSearchParams, useRouter } from 'next/navigation';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from '@workspace/ui/components/alert-dialog';
import confetti from 'canvas-confetti';

type Props = {
  openOnLoad: boolean;
  title?: string;
  description?: string;
  actionLabel?: string;
  clearQueryKey?: string;
};

export const NoticeDialog = ({
  openOnLoad,
  title,
  description,
  actionLabel,
  clearQueryKey,
}: Props) => {
  const [open, setOpen] = useState(openOnLoad);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    setOpen(openOnLoad);
  }, [openOnLoad]);

  const closeAndClean = useCallback(() => {
    const sp = new URLSearchParams(searchParams.toString());
    sp.delete(clearQueryKey || '');

    router.replace(`${pathname}${sp.toString() ? `?${sp}` : ''}`, {
      scroll: false,
    });
    if (actionLabel === 'Great') {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.5, x: 0.5 },
      });
    }

    setOpen(false);
  }, [pathname, router, searchParams]);

  return (
    <AlertDialog
      open={open}
      onOpenChange={(v) => (v ? setOpen(true) : closeAndClean())}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={closeAndClean}>
            {actionLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
